import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import BookingDataService from "../../services/Booking";
import ExpertDataService from "../../services/Expert";
import { FiSettings } from "react-icons/fi";
import { SetPageSizeModal } from "../../components/Modals/SetPageSizeModal";
import { useDisclosure, useToast } from "@chakra-ui/react";
import { SlCalender } from "react-icons/sl";
import { MdOutlineFileDownload } from "react-icons/md";
import PaymentDateModal from "../../components/Modals/PaymentDateModal";
import { SingleSheetRow } from "../../components/List/SingleSheetRow";
import DownloadPaymentModal from "../../components/Modals/DownloadPaymentModal";
import { HiOutlineUsers } from "react-icons/hi";
import { Spinner } from "@chakra-ui/react";
export const BilingSheetOne = () => {
  const toast = useToast();
  const token = localStorage.getItem("logged_in_user_token");
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [expertList, setExpertList] = useState<any>([]);
  const [list, setList] = useState<any>([]);
  const [modal, setModal] = useState<any>("");
  const [fromDate, setFromDate] = useState<any>(null);
  const [toDate, setToDate] = useState<any>(null);
  const [syncLoader, setsyncLoader] = useState<any>(false);
  const [totalPayments, setTotalPayments] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const hasAutoSyncedRef = useRef(false);

  const storedcontrols = localStorage.getItem("logged_in_user_accesscontrols");
  const userControls: any[] = storedcontrols ? JSON.parse(storedcontrols) : [];

  const getDateRange = (
    fromUnixDate: number | null,
    toUnixDate: number | null
  ) => {
    setFromDate(fromUnixDate);
    setToDate(toUnixDate);
  };

  const handlePageSize = (input: number, islock: boolean) => {
    setPageSize(input);
  };

  const fetchData = async () => {
    try {
      const expertsResponse = await ExpertDataService.getExperts(token);
      setExpertList(expertsResponse.data);

      const paymentDetailsResponse = await BookingDataService.getPaymentDetails(
        fromDate,
        toDate,
        page,
        pageSize,
        "captured",
        token
      );
      setTotalPages(paymentDetailsResponse.data.pagination.totalPages);
      setTotalPayments(paymentDetailsResponse.data.pagination.totalRecords);
      setList(paymentDetailsResponse.data.data);
    } catch (error: any) {
      if (error.response.status === 401) {
        toast({
          position: "top",
          title: "Authentication Failed.",
          description: "Your session is expired.",
          status: "error",
          duration: 500,
          isClosable: true,
        });
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }

      console.log(error);
    }
  };

  const syncPayments = (showSuccessToast = true) => {
    setsyncLoader(true);
    BookingDataService.syncPayments()
      .then((res) => {
        fetchData();
        setsyncLoader(false);
        if (showSuccessToast) {
          toast({
            position: "top",
            title: "Payments Synced Successfully",
            description:
              "All payments have been synced successfully from Razorpay",
            status: "success",
            duration: 1500,
            isClosable: true,
          });
        }
      })
      .catch((e) => {
        console.log(e);
        setsyncLoader(false);
        toast({
          position: "top",
          title: "Payment Sync Failed",
          description:
            "There was an error syncing the payments from Razorpay. Please try again later.",
          status: "error",
          duration: 1500,
          isClosable: true,
        });
      });
  };

  useEffect(() => {
    fetchData();
  }, [page, pageSize, fromDate]);

  useEffect(() => {
    if (hasAutoSyncedRef.current) {
      return;
    }
    hasAutoSyncedRef.current = true;
    syncPayments(false);
  }, []);
  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Billing - User Billing</div>
      <div className="p-4">
        <div className="top_section_container">
          <div className="expert_container_item expert_list_button ">
            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => {
                  setModal("setPageSize");
                  onOpen();
                }}
              >
                <FiSettings style={{ fontSize: "20px", margin: "0 5px" }} />
              </button>
              <button
                type="button"
                className="btn action-btn"
                onClick={() => {
                  setModal("filterDate");
                  onOpen();
                }}
              >
                <SlCalender style={{ fontSize: "20px", margin: "0 5px" }} />
              </button>

              {!userControls.includes("hideBillingPayments") && (
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => {
                    setModal("downloadModal");
                    onOpen();
                  }}
                >
                  <MdOutlineFileDownload
                    style={{ fontSize: "20px", margin: "0 5px" }}
                  />
                </button>
              )}

              {!userControls.includes("hideBillingPayments") && (
                <button
                  type="button"
                  className="btn action-btn"
                  onClick={() => {
                    navigate("/billing/userbilling/expertprices");
                  }}
                >
                  <HiOutlineUsers
                    style={{ fontSize: "20px", margin: "0 5px" }}
                  />
                </button>
              )}
              {modal === "setPageSize" && (
                <SetPageSizeModal
                  isOpen={isOpen}
                  onClose={onClose}
                  input={pageSize}
                  func={handlePageSize}
                />
              )}
              {modal === "filterDate" && (
                <PaymentDateModal
                  isOpen={isOpen}
                  onClose={onClose}
                  func={getDateRange}
                />
              )}
              {modal === "downloadModal" && (
                <DownloadPaymentModal isOpen={isOpen} onClose={onClose} />
              )}
            </div>

            <div className="btn-group" role="group">
              <button
                type="button"
                className="btn action-btn"
                onClick={() => syncPayments()}
              >
                {syncLoader ? <Spinner size="sm" /> : "Sync Payments"}
              </button>
            </div>
          </div>
        </div>
        {/* <div className="row m-0 justify-content-between align-items-center">
          <div className="col-sm-4 p-lg-0">
            <div className="btn-group" role="group">

              <button
                type="button"
                className="btn action-btn"
                onClick={() => {
                  setModal("setPageSize");
                  onOpen();
                }}
              >
                <FiSettings style={{ fontSize: "20px", margin: "0 5px" }} />
              </button>

              <button
                type="button"
                className="btn action-btn"
                onClick={() => {
                  setModal("filterDate");
                  onOpen();
                }}
              >
                <SlCalender style={{ fontSize: "20px", margin: "0 5px" }} />
              </button>
            
              <button
                type="button"
                className="btn action-btn"
                onClick={() => {
                  setModal("downloadModal");
                  onOpen();
                }}
              >
                <MdOutlineFileDownload style={{ fontSize: "20px", margin: "0 5px" }} />
              </button>
              <button
                type="button"
                className="btn action-btn"
                onClick={() => {
                  navigate("/billing/userbilling/expertprices");
                }}
              >
                <HiOutlineUsers style={{ fontSize: "20px", margin: "0 5px" }} />
              </button>
              {modal === "setPageSize" && (
                <SetPageSizeModal
                  isOpen={isOpen}
                  onClose={onClose}
                  input={pageSize}
                  func={handlePageSize}
                />
              )}

               {modal === "filterDate" && (
                <PaymentDateModal
                  isOpen={isOpen}
                  onClose={onClose}
                  func={getDateRange}
                />
              )}
               {modal === "downloadModal" && (
                <DownloadPaymentModal
                  isOpen={isOpen}
                  onClose={onClose}
                />
              )}
            </div>
          </div>
        </div> */}

        {/* Main secttion */}
        <div className="main-section" style={{ overflowX: "auto" }}>
          <table className="table">
            <thead>
              <tr>
                <th>Year</th>
                <th>Month</th>
                <th>Payment Id</th>
                <th>Amount</th>
                <th>Total Fee</th>
                <th>Razorpay Fee</th>
                <th>Razorpay Fee GST</th>
                <th>Order Id</th>
                <th>Refunded Amount</th>
                <th>VPA</th>
                <th>Email</th>
                <th>Date Time</th>
                <th>Source</th>
                <th>Status</th>
                <th>Service</th>
                <th>Expert Name</th>
                {!userControls.includes("hideBillingPayments") && (
                  <th>Expert Payment</th>
                )}
                <th>Single/Subs</th>
              </tr>
            </thead>
            <tbody>
              {list && list.length > 0 ? (
                list.map((el: any) => (
                  <SingleSheetRow
                    key={el._id}
                    dbid={el._id}
                    data={el}
                    experts={expertList}
                  />
                ))
              ) : (
                <h1 className="no-data">No Data Found</h1>
              )}
            </tbody>
          </table>
        </div>
        <div className="row m-0 pagination pt-5">
          <div className="col-sm-6 p-lg-0">
            <p>
              Showing {(page - 1) * pageSize + 1} to{" "}
              {page * pageSize > totalPayments
                ? totalPayments
                : page * pageSize}{" "}
              of {totalPayments} entries
            </p>
          </div>
          <div className="col-sm-6 p-lg-0 text-right">
            <div className="btn-group" role="group">
              <button
                type="button"
                className={
                  page === 1
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page - 1)}
                disabled={page === 1 ? true : false}
              >
                {"<< Previous"}
              </button>
              <button type="button" className="btn action-btn selected">
                {page}
              </button>
              <button
                type="button"
                className={
                  page === totalPages || totalPages === 0
                    ? "btn action-btn disabledButton "
                    : "btn action-btn"
                }
                onClick={() => setPage(page + 1)}
                disabled={
                  page === totalPages || totalPages === 0 ? true : false
                }
              >
                {"Next >>"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
